import React from "react";
import FaqTop from "./FaqTop";
import FaqList from "./FaqList";
import SEO from "../SEO";
import { useEffect } from "react";
import ReactGA  from "react-ga4";
const Faqs = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/faqs",
      title: "Frequently Asked Questions | SynergyCare Foundation",
    });
  });
	return (
		<div className='max-w-[1440px] w-[90%] mx-auto lg:pt-40 pt-32  pb-16 relative'>
			<SEO
				title='Frequently Asked Questions | SynergyCare Foundation'
				description='Find answers to common questions about SynergyCare Foundation’s mission, services, and involvement opportunities.'
				name='SynergyCare Foundation'
				type=''
			/>
			<FaqTop />
			<FaqList />
		</div>
	);
};

export default Faqs;
